export default __webpack_public_path__ + "static/rosecutrings-a04456d38d058cee5a8bc164f960acdb.png";